import { IFilter } from '../../interfaces/filter.interface';

export class BooleanFilter implements IFilter<boolean | undefined> {
  private _filterValue: boolean | undefined;

  constructor(startingValue?: boolean) {
    this._filterValue = startingValue;
  }

  public update(value: boolean | undefined): void {
    this._filterValue = value;
  }

  public getFilterValue(): boolean | undefined {
    return this._filterValue;
  }
}
